import React, { useState, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import Header from "../Units/Header";
import { changePasswordRequest, closeForm } from "../../store/actionCreators/account";
import '../../assets/stylesheets/ProfileSlide/ProfileChangePassword.scss';

const fields = ['current', 'new', 'repeat'];

const ChangePassword = ({  }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [formState, setFormState] = useState({
        values: []
    });
    const error = useSelector(state => state.changedPasswordData.changePasswordFail);

    const handleChange = (e) => {
        e.persist();
        setFormState(formState => ({
          ...formState,
          values: {
            ...formState.values,
            [e.target.name]: e.target.value,
          },
        }));
    };
    
    const onClose = () => {
        dispatch(closeForm());
    }
    const requestPasswordChange = useCallback((e) => {
        dispatch(changePasswordRequest({
            password:  formState.values['currentPassword'], 
            newPassword:  formState.values['newPassword'],
            repeatPassword: formState.values['repeatPassword']
        }));
    }, [formState]);

    const hasError = (name) => {
        return error && error[name];
    };

    return (
        <div className={'changePasswordForm'}>
            <Header title='changePasswordTitle' backTo={'/settings'} onClose={onClose}></Header>
            <div className={'fieldSection'}>
                {fields.map(field=>
                    (<div className={`oldPassword passField`} key={field}>
                        {t(`changePassword.${field}`)}
                        <label>
                            <input type="password" 
                                name={`${field}Password`}
                                key={field}
                                onChange={(e) => handleChange(e)} 
                            />
                        </label>
                        {hasError(`${field}Password`) && <div className={'errorMessage'}>
                            {error[`${field}Password`].includes('Invalid current') ? t('error.invalidCurrentPassword'): error[`${field}Password`]}
                        </div>}
                        {/* need to check translation */}
                    </div>)
                )}
            </div>
            <div className={`confirm`}>
                <button className={`primary`} onClick={(e) => requestPasswordChange(e)}>{t('changePassword.confirm')}</button>
            </div>
        </div>
    )
};


export default ChangePassword;
